import { clampChampionshipStarLevel } from './starLadder.js';

/** Paire de stats 1–5 dont la somme est dans [powerMin, powerMax]. */
export function twoStatsForPowerRange(powerMin: number, powerMax: number): [number, number] {
  const target = powerMin + Math.floor(Math.random() * (powerMax - powerMin + 1));
  const minA = Math.max(1, target - 5);
  const maxA = Math.min(5, target - 1);
  const a =
    minA <= maxA
      ? minA + Math.floor(Math.random() * (maxA - minA + 1))
      : clampChampionshipStarLevel(target / 2);
  const b = clampChampionshipStarLevel(target - a);
  return [a, b];
}

export function isStarPairInDivisionBand(
  a: number,
  b: number,
  powerMin: number,
  powerMax: number
): boolean {
  const sum = a + b;
  return sum >= powerMin && sum <= powerMax && a >= 1 && a <= 5 && b >= 1 && b <= 5;
}
